import React, { useContext } from 'react';
import { ITypeVignetteOrderingProcessFields, OfferContext, VignetteContext, getLabelValue } from '@adac-mp/shared';
import { Modal, Typography, Button } from '../../index';

interface IResetDataModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: () => void;
}

export const ResetDataModal = ({ isOpen, onSubmit, onClose }: IResetDataModalProps) => {
	const { labels } = useContext(OfferContext);
	const { contentfulLabels } = useContext(VignetteContext);
	const currentLabels = contentfulLabels as ITypeVignetteOrderingProcessFields;
	return (
		<Modal isOpen={isOpen} title={currentLabels?.resetTitle || 'Fahrzeugklasse wechseln'} onClose={onClose}>
			<Typography className="mb-5 px-3 pt-1.5" component="p" color="text" size="lg">
				{currentLabels?.resetText ||
					'Sind Sie sicher, dass die die Fahrzeugklasse ändern möchten? Ihre bisherigen Eingaben werden damit gelöscht und Sie müssen die Vignette von neuem konfigurieren.'}
			</Typography>
			<Button
				fullWidth
				className="mb-1.5"
				onClick={() => {
					onSubmit();
					onClose();
				}}>
				{getLabelValue('mp.confirmButton', labels) || 'Bestätigen'}
			</Button>
			<Button fullWidth className="mb-1.5" variant="shy" onClick={onClose}>
				{getLabelValue('mp.cancelButton', labels) || 'Abbrechen'}
			</Button>
		</Modal>
	);
};
